export default function TypingIndicator() {
  return (
    <span className="flex h-5 items-center gap-1">
      <span className="size-1.5 animate-bounce rounded-full bg-neutral-500" />
      <span className="size-1.5 animate-bounce rounded-full bg-neutral-500 [animation-delay:150ms]" />
      <span className="size-1.5 animate-bounce rounded-full bg-neutral-500 [animation-delay:300ms]" />
    </span>
  );
}
